var React = require('react');

function Google (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 7C0 3.1402 3.1402 0 7 0C8.55887 0 10.0343 0.501533 11.2669 1.4504L9.64027 3.56347C8.87813 2.9768 7.96513 2.66667 7 2.66667C4.6106 2.66667 2.66667 4.6106 2.66667 7C2.66667 9.3894 4.6106 11.3333 7 11.3333C8.92447 11.3333 10.5599 10.0725 11.1235 8.33333H7V5.66667H14V7C14 10.8598 10.8598 14 7 14C3.1402 14 0 10.8598 0 7Z","fill":"white"}));
}

Google.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Google;

Google.default = Google;
